// Firebase configuration file
// This sets up the connection to your Firebase project

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// =============================================================================
// IMPORTANT: Replace these values with your own Firebase project config!
//
// To get these values:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project (or use existing one)
// 3. Click the gear icon > Project settings
// 4. Scroll down to "Your apps" and click the web icon (</>)
// 5. Register your app and copy the config values below
// =============================================================================

const firebaseConfig = {
  apiKey: "AIzaSyAV60ov7f1oauQxqETz4sRZ9XEl6UTUh20",
  authDomain: "kana-4e741.firebaseapp.com",
  projectId: "kana-4e741",
  storageBucket: "kana-4e741.firebasestorage.app",
  messagingSenderId: "289017718094",
  appId: "1:289017718094:web:cb2a3d5cd9867295cfea1f",
  measurementId: "G-S6DMQP01GE"
};

// Initialize Firebase - this creates the connection to Firebase
const app = initializeApp(firebaseConfig);

// Get the authentication service - used for login/signup
export const auth = getAuth(app);

// Get the Firestore database service - used for storing todos, families, etc.
export const db = getFirestore(app);
